(() => {
  function getTabIndexForKey(key, currentIndex, tabCount) {
    if (tabCount < 2) return currentIndex;

    switch (key) {
      case 'ArrowRight':
        return (currentIndex + 1) % tabCount;
      case 'ArrowLeft':
        return (currentIndex - 1 + tabCount) % tabCount;
      case 'Home':
        return 0;
      case 'End':
        return tabCount - 1;
      default:
        return currentIndex;
    }
  }

  function getTabElements(rootElement) {
    return {
      tabs: Array.from(rootElement.querySelectorAll('[data-kl-tab]')),
      panels: Array.from(rootElement.querySelectorAll('[data-kl-tab-panel]')),
    };
  }

  function updateSelection(tabs, panels, selectedIndex, canMoveFocus) {
    const selectedTab = tabs[selectedIndex];

    if (!selectedTab) return;

    try {
      const selectedKey = selectedTab.dataset.klTab;

      tabs.forEach((tab, index) => {
        const isSelected = index === selectedIndex;

        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.klTabPanel !== selectedKey;
      });

      if (canMoveFocus) selectedTab.focus();
    } catch (error) {
      console.debug('kl-tabs: could not switch panel', { selectedIndex, error });
    }
  }

  function initTabs(rootElement) {
    const { tabs, panels } = getTabElements(rootElement);

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => updateSelection(tabs, panels, index, false));

      tab.addEventListener('keydown', (event) => {
        const nextIndex = getTabIndexForKey(event.key, index, tabs.length);

        if (nextIndex === index) return;

        event.preventDefault();
        updateSelection(tabs, panels, nextIndex, true);
      });
    });

    const renderedIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');

    updateSelection(tabs, panels, Math.max(0, renderedIndex), false);
  }

  function revealPanelForBlock(blockElement) {
    const panel = blockElement.closest('[data-kl-tab-panel]');

    if (!panel) return;

    const rootElement = panel.closest('[data-kl-tabs]');

    if (!rootElement) return;

    const { tabs, panels } = getTabElements(rootElement);
    const selectedIndex = tabs.findIndex((tab) => tab.dataset.klTab === panel.dataset.klTabPanel);

    if (selectedIndex < 0) return;

    updateSelection(tabs, panels, selectedIndex, false);
  }

  document.querySelectorAll('[data-kl-tabs]').forEach(initTabs);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-kl-tabs]').forEach(initTabs);
  });

  document.addEventListener('shopify:block:select', (event) => {
    revealPanelForBlock(event.target);
  });
})();
